module.exports = __webpack_public_path__ + "img/baniere-spores.3951a781.jpg";